// src/App.js

import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './project/context/AuthContext';

import Dashboard from './project/pages/Dashboard';
import NotFoundPage from './project/pages/NotFoundPage';
import Entity from './pages/Entity';
import Auth from './project/pages/Activity/Auth';
import Activity from './project/pages/Activity';
import AuthorizedActivity from './project/pages/Activity/Authorized';
import Module from './pages/Module';

import EntryRequest from './pages/Activity/Component/EntryRequest';
import EntryActionCompnent from './pages/Activity/Component/EntryActionComponent';
import EntryEntity from './pages/Entity/Entry';
import EntryModule from './pages/Module/Entry';
import User from './core/user';
import EntryUser from './core/user/Entry';
import Shift from './core/attendance/shift';
import EntryShift from './core/attendance/shift/Entry';
import CoreEntrySchedule from './core/attendance/schedule/Entry';
import './App.css';
import CoreEmployee from './core/attendance/employee';
import EntryEmployee from './core/attendance/employee/Entry';
import EntryOvertime from './core/attendance/overtime/Entry';
import Attendance from './core/attendance/attendance';
import Salary from './core/attendance/salary';
import BaseProduct from './pages/Base/Product';
import BaseEntryProduct from './pages/Base/Product/Entry';
import Sale from './pages/Base/Transaction';
import History from './pages/Base/History';
import Project from './core/project';
import Home from './website/Home';
import Lnetwork from './website/Lnetwork';

import Outlet from './core/subproject';
import EntryProject from './core/project/Entry';
import EntryOutlet from './core/subproject/Entry';
import Menu from './pages/Menu';
import EntryMenu from './pages/Menu/Entry';
import EntryAccess from './pages/Access/Entry';
import Service from './website/Service';
import Catalog from './website/Catalog';
import Company from './website/Company';
import Procedure from './pages/Procedure';
import EntryProcedure from './pages/Procedure/Entry';
import SortData from './pages/SortData';
import ProtectedRoute from './project/component/ProtectedRoute';
import PublicRoute from './project/component/PublicRoute';
import EntryLayoutCompnent from './pages/Activity/Component/EntryLayoutComponent';
import PrintThermal from './project/pages/Activity/Print/Thermal';

import AwardsPage from './website/Awards';
import './App.css';
import HelloWorld from './project/pages/StudyAbroad/public';
import Universities from './project/pages/StudyAbroad/public/universities';
import University from './project/pages/StudyAbroad/public/universities/University';
import Ocr from './project/pages/Activity/Ocr';
import Facilites from './project/pages/STAYNEST/dashboard/Facilities/Facilites';
import Rooms from './project/pages/STAYNEST/dashboard/Rooms/Rooms';
import EntryRoom from './project/pages/STAYNEST/dashboard/Rooms/EntryRoom';
import Reservations from './project/pages/STAYNEST/dashboard/Reservations/Reservations';
import HomePage from './project/pages/STAYNEST/public';
import HotelDetail from './project/pages/STAYNEST/public/DetailHotel';
import DashboardStayNest from './project/pages/STAYNEST/dashboard';

import Presentation from './website/Presentation';
import FormRequestApp from './website/FormRequestApp';
import PartnerGrid from './website/Partner';
import MerchantB2B from './website/Merchant';
import ClientB2B from './website/Client';
import HelloLPay from './project/pages/LPay';
import TransactionTimeline from './project/pages/TripDeal';
import PrivacyPolicy from './website/PrivacyPolicy';
import Employee from './core/attendance/employee';
import WizardForm from './website/component/requestapp/WizardForm';

const App = () => {
    return (
        <AuthProvider>
            <Router>
                <Routes>
                    <Route path="/timeline" element={<TransactionTimeline />} />

                    <Route path="/print-thermal" element={<PrintThermal />} />
                    <Route path="/public/:link/:params?" element={<Activity />} />
                    <Route path="/activity/auth" element={<ProtectedRoute element={Auth} />} />
                    <Route path="/activity/:link/:params?" element={<ProtectedRoute element={AuthorizedActivity} />} />

                    <Route path='/sort-data' element={<SortData />} />

                    <Route exact path="/privacy-policy" element={<PrivacyPolicy appName={"L`Network"} />} />
                    <Route exact path="/zone-privacy-policy" element={<PrivacyPolicy appName={"Zone"} />} />
                    <Route exact path="/" element={<PublicRoute element={Home} />} />
                    <Route exact path="/invite/:code" element={<Lnetwork />} />

                    <Route path="/service" element={<PublicRoute element={Service} />} />
                    <Route path="/catalog" element={<PublicRoute element={Catalog} />} />
                    <Route path="/about/company" element={<PublicRoute element={Company} />} />
                    <Route path="/about/partnership" element={<PublicRoute element={PartnerGrid} />} />
                    <Route path="/about/client" element={<PublicRoute element={ClientB2B} />} />
                    <Route path="/about/merchant" element={<PublicRoute element={MerchantB2B} />} />
                    <Route path="/request-app" element={<PublicRoute element={WizardForm} />} />
                    <Route path="/request-app-deprecated" element={<PublicRoute element={FormRequestApp} />} />
                    
                    {/* <Route path="/request-app" element={<FormRequestApp />} /> */}

                    <Route path="/admin-login" element={<Auth />} />
                    <Route path="/developer-login" element={<Auth />} />

                    <Route path="/dashboard" element={<ProtectedRoute element={Dashboard} />} />
                    <Route path="/entity" element={<ProtectedRoute element={Entity} />} />
                    <Route path="/add-entity" element={<ProtectedRoute element={EntryEntity} />} />
                    <Route path="/edit-entity/:id" element={<ProtectedRoute element={EntryEntity} />} />

                    <Route path="/procedure" element={<ProtectedRoute element={Procedure} />} />
                    <Route path="/add-procedure" element={<ProtectedRoute element={EntryProcedure} />} />
                    <Route path="/edit-procedure/:id" element={<ProtectedRoute element={EntryProcedure} />} />

                    <Route path="/menu" element={<ProtectedRoute element={Menu} />} />
                    <Route path="/add-menu" element={<ProtectedRoute element={EntryMenu} />} />
                    <Route path="/edit-menu/:id" element={<ProtectedRoute element={EntryMenu} />} />

                    <Route path="/module" element={<ProtectedRoute element={Module} />} />
                    <Route path="/add-module" element={<ProtectedRoute element={EntryModule} />} />
                    <Route path="/edit-module/:id" element={<ProtectedRoute element={EntryModule} />} />

                    <Route path="/activity-request/:action/:id_module_action" element={<ProtectedRoute element={EntryRequest} />} />
                    <Route path="/edit-activity-request/:action/:id_module_action/:id" element={<ProtectedRoute element={EntryRequest} />} />

                    <Route path="/activity-component/:id_module/:id_parent" element={<ProtectedRoute element={EntryActionCompnent} />} />
                    <Route path="/edit-activity-component/:id_module/:id_parent/:id" element={<ProtectedRoute element={EntryActionCompnent} />} />

                    <Route path="/edit-activity-layout/:id_module/:id_parent/:id" element={<ProtectedRoute element={EntryLayoutCompnent} />} />

                    {/* CORE */}
                    <Route path="/project" element={<ProtectedRoute element={Project} />} />
                    <Route path="/add-project" element={<ProtectedRoute element={EntryProject} />} />
                    <Route path="/edit-project/:id" element={<ProtectedRoute element={EntryProject} />} />

                    <Route path="/subproject/:project" element={<ProtectedRoute element={Outlet} />} />
                    <Route path="/add-subproject/:project" element={<ProtectedRoute element={EntryOutlet} />} />
                    <Route path="/edit-subproject/:project/:id" element={<ProtectedRoute element={EntryOutlet} />} />

                    <Route path="/users" element={<ProtectedRoute element={User} />} />
                    <Route path="/add-user" element={<ProtectedRoute element={EntryUser} />} />
                    <Route path="/edit-user/:id" element={<ProtectedRoute element={EntryUser} />} />

                    <Route path="/access-menu" element={<ProtectedRoute element={EntryAccess} />} />

                    <Route path="/employee" element={<ProtectedRoute element={CoreEmployee} />} />
                    <Route path="/add-employee" element={<ProtectedRoute element={EntryEmployee} />} />
                    <Route path="/edit-employee/:id" element={<ProtectedRoute element={EntryEmployee} />} />

                    <Route path="/attendance-shift" element={<ProtectedRoute element={Shift} />} />
                    <Route path="/add-attendance-shift" element={<ProtectedRoute element={EntryShift} />} />
                    <Route path="/edit-attendance-shift/:id" element={<ProtectedRoute element={EntryShift} />} />

                    <Route path="/attendance-schedule/:id_hs_employee" element={<ProtectedRoute element={CoreEntrySchedule} />} />
                    <Route path="/attendance/:id_hs_employee" element={<ProtectedRoute element={Attendance} />} />

                    <Route path="/salary" element={<ProtectedRoute element={Salary} />} />

                    <Route path="/attendance-overtime" element={<ProtectedRoute element={Employee} />} />
                    <Route path="/add-attendance-overtime/:id_attendance" element={<ProtectedRoute element={EntryOvertime} />} />
                    <Route path="/edit-attendance-overtime/:id_attendance/:id" element={<ProtectedRoute element={EntryOvertime} />} />

                    {/* START SUPERAPP */}
                    <Route path="/activity-super/awards-applaunch" element={<ProtectedRoute element={AwardsPage} />} />
                    {/* END SUPERAPP */}

                    
                    {/* START STUDY ABROAD */}
                    <Route path="/hello-world" element={<HelloWorld />} />
                    <Route path="/universities" element={<Universities />} />
                    <Route path="/university/:slug" element={<University />} />

                    <Route path="/universities" element={<Universities />} />
                    <Route path="/university/:slug" element={<University />} />
                    {/* END STUDY ABROAD */}

                    {/* START STAY NEST */}
                    <Route path="/activity-staynest/dashboard" element={<ProtectedRoute element={DashboardStayNest} />} />
                    <Route path="/activity-staynest/manage-facilites" element={<ProtectedRoute element={Facilites} />} />
                    <Route path="/activity-staynest/manage-rooms" element={<ProtectedRoute element={Rooms} />} />
                    <Route path="/activity-staynest/reservations" element={<ProtectedRoute element={Reservations} />} />
                    <Route path="/activity-staynest/room/new" element={<ProtectedRoute element={EntryRoom} />} />
                    <Route path="/activity-staynest/room/edit/:id?" element={<ProtectedRoute element={EntryRoom} />} />

                    <Route path="/activity-staynest/home" element={<HomePage />} />
                    <Route path="/activity-staynest/room/detail/:id?/:date?" element={<HotelDetail />} />

                    {/* END STAY NEST */}

                    {/* TEMPLATE */}
                    <Route path="/data-product" element={<ProtectedRoute element={BaseProduct} />} />
                    <Route path="/add-product" element={<ProtectedRoute element={BaseEntryProduct} />} />
                    <Route path="/edit-product/:id" element={<ProtectedRoute element={BaseEntryProduct} />} />

                    <Route path="/sale" element={<ProtectedRoute element={Sale} />} />
                    <Route path="/history" element={<ProtectedRoute element={History} />} />
                    {/* END TEMPLATE */}
                    
                    <Route path="*" element={<NotFoundPage />} />
                </Routes>
            </Router>
        </AuthProvider>
    );
};

export default App;